import { render, staticRenderFns } from "./popups.vue?vue&type=template&id=3d1ec88d"
import script from "./popups.vue?vue&type=script&lang=js"
export * from "./popups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports